import React from "react";

export default () => (
    <div>
        <img src="./assets/images/newgroup-banner.jpg" alt="" className="banner" />
    </div>
);